import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, Progress, SectionHeader, TitleHeader } from 'web-library';
import { useGetExamLevelsAndResourceTypes } from '../../../api-refactored/onlineTutorials/useGetExamLevelsAndResourceTypes';
import ResourceFormDataView from '../../../modules/usefulInformation/components/ResourceFormDataView';

const AddResource = () => {
  const { t } = useTranslation();

  const [isSuccess, setIsSucess] = useState<boolean>(false);

  const { data } = useGetExamLevelsAndResourceTypes({
    onSuccess: () => {
      setIsSucess(true);
    },
  });

  return (
    <>
      <TitleHeader title={t('usefulInformation->>Listing.UsefulInformation')} />
      <ContentTemplate>
        <SectionHeader title={t('usefulInformation->>Listing.AddResource')} />
        {isSuccess ? (
          <ResourceFormDataView examLevelData={data?.examLevels || []} />
        ) : (
          <Progress color="secondary" />
        )}
      </ContentTemplate>
    </>
  );
};

export default AddResource;
